import { supabase } from '@/lib/safeSupabase';
import type { TaxScenarioInput, TaxResults } from './types';
import { normalizeAltFundFields } from './altFundFields';

export async function calculateTaxServer(input: TaxScenarioInput): Promise<TaxResults> {
  const { data, error } = await supabase.functions.invoke('calculate-tax', { body: input });
  if (error) {
    let msg = error.message;
    try { const body = await (error as any).context?.json(); if (body?.error) msg = body.error; } catch { /* not JSON: keep the generic message */ }
    throw new Error(msg);
  }
  return normalizeAltFundFields(data as TaxResults);
}
